import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background-50 px-4">
      <div className="text-center">
        <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-background-100 flex items-center justify-center">
          <i className="ri-cup-line text-3xl text-primary-500" />
        </div>
        <h1 className="font-heading text-6xl md:text-8xl font-bold text-foreground-300 mb-2">
          404
        </h1>
        <p className="font-heading text-xl md:text-2xl text-foreground-700 mb-2">
          Page Not Found
        </p>
        <p className="text-foreground-500 text-sm md:text-base max-w-md mx-auto mb-8">
          The page you are looking for may have been moved or does not exist.
          Let us get you back to enjoying some chai.
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 text-sm font-medium rounded-md hover:bg-primary-600 transition-colors"
        >
          <i className="ri-home-line" />
          Back to Home
        </Link>
      </div>
    </div>
  );
}